export default __webpack_public_path__ + "static/media/sustainability6.57f04838.webp";